export default __webpack_public_path__ + "static/media/truckRojevasTablet.f9f2a26c.jpg";